export function abbreviateNumber(number: number, fractionDigits: number = 0) {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' }
  ];

  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const item = lookup
    .slice()
    .reverse()
    .find(function(item) {
      return number >= item.value;
    });

  if (item && item.value > 1) {
    return (
      Number(number / item.value)
        .toFixed(2)
        .replace(rx, '$1') + item.symbol
    );
  }

  return number ? Number(number).toFixed(fractionDigits) : 0;
}
